import React from "react";
import PropTypes from "prop-types";
import { useI18n } from "../i18n/LanguageContext";

const SearchStatus = ({ length }) => {
  const { t } = useI18n();
  return (
    <span className="py-5 px-5 bg-lime-50 rounded-md font-mono font-extrabold">
      {length > 0 ? t("search.players", { count: length }) : t("search.none")}
    </span>
  );
};

SearchStatus.propTypes = {
  length: PropTypes.number,
};

export default SearchStatus;
